
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitch01On as ObiSwitch01OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-01-on.js';
 
 
 

 
 export const ObiSwitch01On = createComponent({
   react: React,
   tagName: 'obi-switch-01-on',
   elementClass: ObiSwitch01OnElement,
   events: {
     
   }
  });
 
 